import React from 'react'
import { Accordion, AccordionSummary, InputBase, AccordionDetails, Typography, NativeSelect, Grid, Paper, Button, Input } from '@material-ui/core'
import CurrencyTextField from '@unicef/material-ui-currency-textfield'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import Header from '../../../../layout/Header'
import Subheader from '../../../../layout/Subheader'
import Loading from '../../../../components/Loading'
import InputMask from 'react-input-mask';

import { formatDateTimeToRender, formatDateToRender } from '../../../../utils/functions'

import useStyles from './style'

function Render ({
  inputs,
  handleInputChange,
  getErros,
  setErros,
  getLoading,
  onSubmit
}) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Editando taxas faixas: " loading={getLoading} submitText="Atualizar" submit={onSubmit} back={false} subanchor={true} />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {getLoading
            ? (<Loading />)
            : (
            <form onSubmit={onSubmit}>
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Informações</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>
                <Grid item xs={6}>
                  <label className={classes.label}>Valor Inicial</label>
                  <Paper className={classes.medium} elevation={0}>

                  <CurrencyTextField
                    value={inputs.valorInicial !== '0,00' ? inputs.valorInicial : 0}
                    currencySymbol="R$"
                    placeholder="Digite o valor inicial"
                    modifyValueOnWheel={false}
                    decimalCharacter=","
                    style={{
                      padding: 0,
                      width: '100%'
                    }}
                    InputProps={{
                      className: classes.inputSalario
                    }}
                    digitGroupSeparator="."
                    name="valorInicial"
                    error={getErros.includes('ValorInicial')}
                    onChange={handleInputChange}
                    onBlur={event => getErros.includes('ValorInicial') && setErros(
                      getErros.filter(function (item) {
                        return item !== 'ValorInicial'
                      })
                    )}
                  />

                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Valor Final</label>
                  <Paper className={classes.medium} elevation={0}>

                  <CurrencyTextField
                    value={inputs.valorFinal !== '0,00' ? inputs.valorFinal : 0}
                    currencySymbol="R$"
                    placeholder="Digite o valor final"
                    modifyValueOnWheel={false}
                    decimalCharacter=","
                    style={{
                      padding: 0,
                      width: '100%'
                    }}
                    InputProps={{
                      className: classes.inputSalario
                    }}
                    digitGroupSeparator="."
                    name="valorFinal"
                    error={getErros.includes('ValorFinal')}
                    onChange={handleInputChange}
                    onBlur={event => getErros.includes('ValorFinal') && setErros(
                      getErros.filter(function (item) {
                        return item !== 'ValorFinal'
                      })
                    )}
                  />

                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Taxa</label>
                  <Paper className={classes.medium} elevation={0}>
                  <CurrencyTextField
                    value={inputs.taxa !== '0,00' ? inputs.taxa : 0}
                    currencySymbol="%"
                    placeholder="Taxa"
                    modifyValueOnWheel={false}
                    decimalCharacter=","
                    minimumValue="0"
                    maximumValue="100"
                    style={{
                      padding: 0,
                      width: '100%'
                    }}
                    InputProps={{
                      className: classes.inputSalario
                    }}
                    digitGroupSeparator="."
                    name="taxa"
                    error={getErros.includes('Taxa')}
                    onChange={handleInputChange}
                    onBlur={event => getErros.includes('Taxa') && setErros(
                      getErros.filter(function (item) {
                        return item !== 'Taxa'
                      })
                    )}
                  />
                  </Paper>
                </Grid>

                <Grid item xs={6} className={classes.item}>
                <label className={classes.label}>Status</label>
                  <Paper className={classes.medium} elevation={0}>

                  <NativeSelect
                        className={classes.input}
                        value={inputs.status}
                        name="status"
                        onChange={handleInputChange}
                        error={getErros.includes('Status')}
                        onBlur={event => getErros.includes('Status') && setErros(
                          getErros.filter(function (item) {
                            return item !== 'Status'
                          })
                        )}
                      >
                        <option value="Ativo">Ativo</option>
                        <option value="Inativo">Inativo</option>
                      </NativeSelect>

                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <label className={classes.label}>Data Início Cobrança</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputMask
                      mask="99/99/9999"
                      value={
                        inputs.dataInicioCobranca &&
                        formatDateToRender(inputs.dataInicioCobranca)
                      }
                      name="dataInicioCobranca"
                      autocomplete="off"
                      onBlur={(event) =>
                        getErros.includes('dataInicioCobranca') &&
                        setErros(
                          getErros.filter(function (item) {
                            return item !== 'dataInicioCobranca';
                          }),
                        )
                      }
                      disabled={false}
                      onChange={handleInputChange}
                    >
                      {() => (
                        <Input
                          className={classes.input}
                          name="dataInicioCobranca"
                          placeholder="Data Início Cobrança"
                          error={getErros.includes('dataInicioCobranca')}
                        />
                      )}
                    </InputMask>
                  </Paper>
                </Grid>
                <Grid item xs={6} className={classes.item}>
                  <label className={classes.label}>Data Final Cobrança</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputMask
                      mask="99/99/9999"
                      value={
                        inputs.dataFinalCobranca &&
                        formatDateToRender(inputs.dataFinalCobranca)
                      }
                      name="dataFinalCobranca"
                      autocomplete="off"
                      onBlur={(event) =>
                        getErros.includes('dataFinalCobranca') &&
                        setErros(
                          getErros.filter(function (item) {
                            return item !== 'dataFinalCobranca';
                          }),
                        )
                      }
                      disabled={false}
                      onChange={handleInputChange}
                    >
                      {() => (
                        <Input
                          className={classes.input}
                          name="dataFinalCobranca"
                          placeholder="Data Final Cobrança"
                          error={getErros.includes('dataFinalCobranca')}
                        />
                      )}
                    </InputMask>
                  </Paper>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>

          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              className={classes.summary}
            >
              <Typography className={classes.heading}>Dados do Registro</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.details}>
              <Grid container>

              <Grid item xs={6}>
                  <label className={classes.label}>Data de Registro</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataRegistro && formatDateTimeToRender(inputs.dataRegistro)}
                      readOnly
                      placeholder="Data do Registro"
                    />
                  </Paper>
                </Grid>

                <Grid item xs={6}>
                  <label className={classes.label}>Data da Atualização</label>
                  <Paper className={classes.medium} elevation={0}>
                    <InputBase
                      className={classes.input}
                      value={inputs.dataAtualizacao ? formatDateTimeToRender(inputs.dataAtualizacao) : ''}
                      readOnly
                      placeholder="Data da Atualização"
                    />
                  </Paper>
                </Grid>

              </Grid>
            </AccordionDetails>
            </Accordion>

          <div className={classes.divButton}>
            <Button variant="contained" type="submit" className={classes.button}>Atualizar</Button>
          </div>
          </form>
              )}
        </div>

      </div>
    </div>
  )
}

export default Render
